import getPromotions from './get-promotions';

export default {
	getPromotions
};
